module.exports = __webpack_public_path__ + "img/1.85ba6d8d.jpg";